import React, { useEffect, useState } from "react";

export function Loader() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="20px"
      height="20px"
      viewBox="0 0 50 50"
      className="fill-current"
    >
      <path d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
        <animateTransform
          attributeType="xml"
          attributeName="transform"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="0.6s"
          repeatCount="indefinite"
        />
      </path>
    </svg>
  );
}

export function LoadingScreen({
  text: primaryText = "",
  secondaryText,
}: {
  text?: string;
  secondaryText?: { wait: number; text: string };
}) {
  const [text, setText] = useState("");
  useEffect(() => {
    setText(primaryText);
  }, [primaryText]);
  useEffect(() => {
    if (!secondaryText) {
      return;
    }
    setTimeout(() => {
      setText(secondaryText.text);
    }, secondaryText.wait);
  }, [secondaryText]);
  return (
    <div className="inset-0 absolute flex justify-center items-center">
      <div className="flex flex-col justify-center items-center">
        <svg
          className="animate-spin h-12 w-12 text-black"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
        <div className="mt-2">
          {text.split("\n").map((t, i) => (
            <p key={`${t}-${i}`}>{t}</p>
          ))}
        </div>
      </div>
    </div>
  );
}
